import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { mergeMap, map, catchError, concatMap, finalize, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Router } from '@angular/router';

import { addNewStore } from '../actions/auth.actions';
import { NotificationService } from '../../shared/services/notification.service';
import { PremiitError } from '../../utils/premiit-error';
import { ResponseData } from '../../utils/response';
import { Store } from '../../pages/stores/store';
import { StoreService } from '../../pages/stores/store.service';
import * as storeActions from '../actions/stores.actions';

@Injectable()
export class StoresEffects {
  constructor(private actions$: Actions, private storeService: StoreService, private notify: NotificationService,
    private router: Router) {}

  public findStoresEffect = createEffect(
    () => this.actions$.pipe(
      ofType(storeActions.getStoresAction),
      mergeMap(() => {
        return this.storeService.getStores()
          .pipe(
            map((response: ResponseData<Store[]>) => {
              const stores = response.data;
              return storeActions.getStoresSuccessAction({ stores });
            }),
            catchError(( error: PremiitError ) => {
              this.notify.customError(error);
              return of(storeActions.getStoresError({ error }));
            })
          );
      })
    )
  );

  public createStoreEffect = createEffect(
    () => this.actions$.pipe(
      ofType(storeActions.createStoreAction),
      mergeMap((action) => {
        return this.storeService.createStore(action.store)
          .pipe(
            map((responseData: ResponseData<Store>) => responseData.data),
            concatMap( (store: Store)  => [
              storeActions.createStoreSuccessAction({ store }),
              addNewStore({ store })
            ]),
            tap(() => {
              this.notify.success('Sucursal creada con éxito');
              this.router.navigate(['stores']);
            }),
            catchError((error: PremiitError) => {
              this.notify.customError(error);
              return of(storeActions.createStoreError({ error }));
            })
          );
      })
    )
  );

  public updateStoreEffect = createEffect(
    () => this.actions$.pipe(
      ofType(storeActions.updateStoreAction),
      mergeMap((action) => {
        return this.storeService.updateStore(action.store)
          .pipe(
            map((response: ResponseData<Store>) => {
              const store = response.data;
              return storeActions.updateStoreSuccess({ store });
            }),
            tap(() => {
              this.notify.success('Sucursal editada con éxito');
              this.router.navigate(['stores']);
            }),
            catchError((error: PremiitError) => {
              this.notify.customError(error);
              return of(storeActions.updateStoreError({ error }));
            })
          );
      })
    )
  );

  public deleteStoreEffect = createEffect(
    () => this.actions$.pipe(
      ofType(storeActions.deleteStoreAction),
      mergeMap((action) => {
        return this.storeService.deleteStore(action.store)
          .pipe(
            map((response: ResponseData<Store>) => storeActions.deleteStoreSuccess({ store: response.data })),
            tap(() => {
              this.notify.success('Sucursal eliminada con éxito');
              this.router.navigate(['stores']);
            }),
            catchError((error: PremiitError) => {
              this.notify.customError(error);
              return of(storeActions.updateStoreError({ error }));
            })
          );
      })
    )
  );
}
